import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { defaultDividerName, defaultDividerRole, defaultTextColor, } from '../../utils/defaults';
import { toNormalizedHueSatBr, toRgbAsHex } from '../../utils/color';
import * as cssUtils from '../../utils/css-utils';
import { adjustImage } from '../../utils/adjust-image';
import { crossDeviceDividerMap, dividerWidthMap, dividerHeightMap, defaultHeight, defaultWidth, } from './divider-map';
const singleImageAdjustment = ({ dividerKey }) => {
    const height = dividerHeightMap[dividerKey];
    const width = dividerWidthMap[dividerKey];
    return ({ hue, sat, br }) => ({
        al: 'c',
        h: height || defaultHeight,
        q: 100,
        w: width || defaultWidth,
        // FYI: adding params in different order might cause different result;
        br,
        sat,
        hue,
    });
};
export const getDividerSection = ({ region, composerData, css, }) => {
    if (region.type !== RegionType.Divider) {
        throw Error('Divider must be passed');
    }
    const isDecorator = (get(region, 'data.role') || defaultDividerRole) === 'decorator';
    const defaultColorSetting = isDecorator
        ? 'so-global-divider2'
        : 'so-global-divider';
    const defaultDividerKeySetting = isDecorator
        ? 'defaultDecoratorName'
        : 'defaultDividerName';
    const color = get(region, 'data.styles.fill') ||
        get(css, `${defaultColorSetting}.fill`) ||
        defaultTextColor;
    const hueSatBr = toNormalizedHueSatBr(color);
    const dividerKey = get(region, 'data.shape') ||
        get(composerData, `styles.settings.${defaultDividerKeySetting}`) ||
        defaultDividerName;
    const dividerImage = crossDeviceDividerMap[dividerKey];
    const dividerType = region.data.role === 'decorator' ? 'divider--decorator' : 'divider--normal';
    const desktopAdjustmentModel = singleImageAdjustment({ dividerKey });
    const userOverrides = get(region, 'data.styles.region');
    const rules = [
        userOverrides,
        css[`so-global-region-${dividerType}`],
        css['so-global-region'],
    ];
    const visibility = get(region, 'data.visibility');
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true, visibility);
    const margin = cssUtils.margin(rules);
    const padding = cssUtils.padding(rules);
    const containerBackground = cssUtils.containerBackgroundColor(rules);
    const borderWidth = cssUtils.containerBorderWidth(rules);
    const borderStyle = cssUtils.containerBorderStyle(rules);
    const borderColor = cssUtils.containerBorderColor(rules);
    const containerBorder = (!!borderStyle &&
        [borderWidth, borderStyle, borderColor].filter(Boolean).join(' ')) ||
        undefined;
    const htmlDividerStyles = getHtmlDividerStyles(dividerKey, color);
    if (htmlDividerStyles && htmlDividerStyles.width !== '100%') {
        // TODO: very strange code, need to doublecheck live.
        padding.left = 0;
        padding.right = 0;
    }
    return {
        cssClass: mobileCssClass,
        dividerImageDesktop: dividerImage &&
            adjustImage(dividerImage, desktopAdjustmentModel(hueSatBr)),
        htmlDividerStyles,
        dividerWidth: dividerWidthMap[dividerKey] || defaultWidth,
        dividerHeight: dividerHeightMap[dividerKey] || defaultHeight,
        outerPadding: margin,
        innerPadding: padding,
        containerBackground,
        containerBorder,
        visibility,
    };
};
function getHtmlDividerStyles(dividerKey, color) {
    const full = '100%';
    const short = '62px';
    const hexColor = toRgbAsHex(color);
    switch (dividerKey) {
        case 'divider1':
            return {
                border: `1px solid ${hexColor}`,
                width: full,
            };
        case 'divider5':
            return {
                border: `3px solid ${hexColor}`,
                width: full,
            };
        case 'divider6':
            return {
                border: `8px solid ${hexColor}`,
                width: full,
            };
        case 'divider9':
            return {
                border: `2px solid ${hexColor}`,
                width: short,
            };
        case 'divider10':
            return {
                border: `6px solid ${hexColor}`,
                width: short,
            };
        default:
            return null;
    }
}
//# sourceMappingURL=get-divider-section.js.map